export const getCurrentItemIndexByItemId = (items: any[], itemId: string): number => {
  return items.findIndex(item => item.id === itemId)
}

export const getCurrentItemByItemId = (items: any[], itemId: string) => {
  return items.find(item => item.id === itemId)
}